function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys2 = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys2 = ownKeys2.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys2.forEach(function(key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { createBrowserClient } from "@slardar/web/sg";
import { Mode, Region, SDK_BID, VERSION } from "../constants/env";
class SlardarContainer {
  constructor(config, sdkContext) {
    this.sendEvent = (data) => {
      if (this._client && this._client.sendEvent) {
        this._client.sendEvent(data);
      }
    };
    this.captureException = (error) => {
      if (this._client && this._client.captureException) {
        this._client.captureException(error);
      }
    };
    this.reportActualFMP = () => {
    };
    const { slardar: customSlardarConfig } = config !== null && config !== void 0 ? config : {};
    const { region = Region.US_EAST, bid: sdkBid = SDK_BID, mode = Mode.PRODUCTION, consumerBid, version = VERSION, appId, appVersion, tenant } = sdkContext !== null && sdkContext !== void 0 ? sdkContext : {};
    this._client = createBrowserClient();
    let defaultSlardarConfig = {};
    switch (region) {
      case Region.US_EASTRED:
      case Region.EU_TTP:
      case Region.EU_TTP2: {
        defaultSlardarConfig = {
          domain: "https://mon16-normal-useastred.tiktokv.eu",
          pluginPathPrefix: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/slardar/fe/sdk-web/plugins"
        };
        break;
      }
      case Region.US_TTP:
      case Region.US_TTP2: {
        defaultSlardarConfig = {
          domain: "https://mon16-normal-useast5.tiktokv.us",
          pluginPathPrefix: "https://lf16-cdn-tos.tiktokcdn-us.com/obj/static-tx/slardar/fe/sdk-web/plugins"
        };
        break;
      }
      case Region.US_EAST:
      case Region.SINGAPORE_CENTRAL:
      default: {
        defaultSlardarConfig = {
          domain: "https://mon.tiktokv.com",
          pluginPathPrefix: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/slardar/fe/sdk-web/plugins"
        };
        break;
      }
    }
    if (this._client) {
      this._client("context.merge", {
        appId: String(appId),
        appVersion: String(appVersion !== null && appVersion !== void 0 ? appVersion : "0.0.0"),
        tenant: String(tenant)
      });
      this._client("init", _object_spread_props(_object_spread({}, defaultSlardarConfig, customSlardarConfig), {
        bid: sdkBid,
        pid: consumerBid ? consumerBid : window.location.href,
        release: version,
        env: mode,
        plugins: {
          pageview: false,
          // set jsError to true to enable captureException
          jsError: {
            onerror: false,
            onunhandledrejection: false
          },
          tti: false,
          performance: false,
          resource: false,
          ajax: false,
          fetch: false,
          fmp: false,
          blankScreen: false
        }
      }));
      this._client("start");
    }
  }
}
const createSlardarClientAndInit = (config, sdkContext) => {
  let slardarContainer = null;
  if ((config === null || config === void 0 ? void 0 : config.slardar) !== false) {
    try {
      slardarContainer = new SlardarContainer(config, sdkContext);
    } catch (e) {
    }
  }
  return slardarContainer;
};
export {
  createSlardarClientAndInit
};

//# sourceMappingURL=SlardarUtil.js.map